<div class="app-footer proco-gradient footer-links">
  <a routerLink="/imprint">{{'NAV.IMPRINT' | translate}}</a>
  <span>  |  </span>
  <a routerLink="/privacy">{{'PRIVACY.PRIVACY_POLICY' | translate}}</a>
</div>
